<div class="h-100  m-0">
    <div class="btn {{buttonClass}} pointer navbar-color align-items-center d-flex justify-content-center {{disabled ? 'disabled' : ''}} {{active ? 'active ' : ''}}">
        <div class="d-flex justify-content-center">
            <i [ngClass]="{'color-secondary-information': !active, 'color-primary-blue': active}"
               class="{{ icon }} m-auto p-3"></i>
        </div>
    </div>
    @if (alwaysShowText) {
        <div
            [ngClass]="{'color-secondary-information': !active, 'color-primary-blue': active}"
            class="text-center">{{ buttonText }}
        </div>
    }
</div>